import { useId, useState } from 'react';
import useLang from 'lang';

interface AccountFiltersProps {
  activeFilterCount: number;
  children: React.ReactNode;
}

/**
 * Keeps account filters visible on larger screens and collapsible on phones.
 */
export default function AccountFilters({ activeFilterCount, children }: AccountFiltersProps) {
  const { _t } = useLang();
  const [expanded, setExpanded] = useState(false);
  const contentId = useId();
  const collapsedLabel = `${_t('Filters')}${activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}`;

  return (
    <section className="account-filter-panel">
      <button
        type="button"
        className="account-filter-toggle"
        aria-controls={contentId}
        aria-expanded={expanded}
        onClick={() => setExpanded((current) => !current)}
      >
        {expanded ? _t('Hide filters') : collapsedLabel}
      </button>
      <div
        id={contentId}
        className={`account-filters${expanded ? ' account-filters--expanded' : ''}`}
        data-testid="account-filter-content"
      >
        {children}
      </div>
    </section>
  );
}
